var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row my-4" }, [
    !_vm.isReadOnly &&
    !_vm.isAddMode &&
    _vm.canAddProponents &&
    !_vm.isRenewalOrAmendment
      ? _c("div", { staticClass: "row col-12" }, [
          _c(
            "div",
            { staticClass: "col-11 my-3" },
            [
              _c("custom-input", {
                attrs: {
                  icon: "fal fa-search color-primary-2",
                  "left-icon": "",
                  placeholder: "SSN o Nombre del Proveedor",
                  "prepend-icon-type": "success"
                },
                on: { input: _vm.onSsnInput },
                model: {
                  value: _vm.ssnName,
                  callback: function($$v) {
                    _vm.ssnName = $$v
                  },
                  expression: "ssnName"
                }
              })
            ],
            1
          ),
          !_vm.isReadOnly && !_vm.isAddMode
            ? _c(
                "div",
                { staticClass: "col-auto my-3" },
                [
                  _c("action-button", {
                    attrs: {
                      i: "fal fa-search",
                      text: "Buscar",
                      variant: "success px-3"
                    },
                    on: { click: _vm.searchByCriteria }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm.isAddMode && !_vm.isRenewalOrAmendment
      ? _c(
          "div",
          { staticClass: "col-12 my-3" },
          [
            _c("add-provider", {
              on: { add: _vm.onAddNewContractor, cancel: _vm.onToggleAddForm },
              model: {
                value: _vm.ssnName,
                callback: function($$v) {
                  _vm.ssnName = $$v
                },
                expression: "ssnName"
              }
            })
          ],
          1
        )
      : _vm._e(),
    !_vm.isReadOnly &&
    !_vm.isAddMode &&
    _vm.canAddProponents &&
    !_vm.isRenewalOrAmendment
      ? _c(
          "div",
          { staticClass: "col-12" },
          [
            _vm.searchResult
              ? _c("custom-separator", {
                  staticClass: "my-4",
                  attrs: { text: "Resultados" }
                })
              : _vm._e(),
            _vm._l(_vm.filteredResults, function(row) {
              return _c(
                "div",
                {
                  key: "res-" + row?.id,
                  staticClass: "rounded p-3 bg-gray my-3 item-container"
                },
                [
                  _c("div", { staticClass: "row d-flex align-items-center" }, [
                    _c("div", { staticClass: "col-12 col-md-2" }, [
                      _c("div", { staticClass: "text-center border-right" }, [
                        _c(
                          "span",
                          {
                            staticClass: "badge badge-pill px-3 py-2 font-14",
                            style: {
                              "--item-status-color": _vm.color(row.status.id)
                            }
                          },
                          [_vm._v(" " + _vm._s(row.status.name) + " ")]
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "col-12 col-md" }, [
                      _c("div", { staticClass: "data-name" }, [
                        _vm._v("Nombre del Proponente:")
                      ]),
                      _c("div", { staticClass: "font-weight-bold" }, [
                        _vm._v(" " + _vm._s(_vm._f("empty")(row.name)) + " ")
                      ])
                    ]),
                    _c("div", { staticClass: "col-12 col-md" }, [
                      _c("div", { staticClass: "data-name" }, [
                        _vm._v("Teléfono:")
                      ]),
                      _c("div", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm._f("phone")(row.phoneNumber)))
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md" },
                      [
                        _c("div", { staticClass: "data-name" }, [
                          _vm._v("Correo Electrónico:")
                        ]),
                        _c("custom-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: row.email,
                            callback: function($$v) {
                              _vm.$set(row, "email", $$v)
                            },
                            expression: "row.email"
                          }
                        })
                      ],
                      1
                    ),
                    !_vm.isReadOnly
                      ? _c(
                          "div",
                          { staticClass: "col-12 col-md-1 custom-pl" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-md-end h-100"
                              },
                              [
                                _c("check-box", {
                                  staticClass: "row-check",
                                  attrs: { value: false },
                                  on: { input: () => _vm.onSelectResult(row) }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              )
            }),
            _vm.showNoResults
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify content-center flex-column align-items-center my-5"
                  },
                  [
                    _c("custom-result-not-found", {
                      attrs: { text: "No se encontró Contratista." }
                    }),
                    _vm.showAddLink
                      ? _c(
                          "a",
                          {
                            staticClass: "text-green pointer",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.onToggleAddForm.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fas fa-file-plus mr-2" }),
                            _vm._v(" Añadir Contratista ")
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("custom-separator", {
          staticClass: "my-4",
          attrs: { text: "Seleccionados" }
        })
      ],
      1
    ),
    _c("div", { staticClass: "row col-12 align-items-center" }, [
      _c("div", { staticClass: "col-3" }, [
        _c("i", { staticClass: "fas fa-user text-orange mr-2" }),
        _c("strong", { staticClass: "text-muted" }, [_vm._v("Proponentes")]),
        _c(
          "span",
          { staticClass: "badge custom-counter-bg text-white p-2 mx-2" },
          [_vm._v(" " + _vm._s(_vm.proponentsCounter) + " ")]
        )
      ]),
      _c("div", { staticClass: "col-9" }, [
        _vm.showMinimumAlert
          ? _c(
              "div",
              { staticClass: "alert alert-warning", attrs: { role: "alert" } },
              [
                _c("i", { staticClass: "fas fa-bell-exclamation mr-2" }),
                _c("strong", [
                  _vm._v(" " + _vm._s(_vm.minimumProponentsAlertText) + " ")
                ])
              ]
            )
          : _vm._e()
      ])
    ]),
    _c(
      "div",
      { staticClass: "col-12" },
      _vm._l(_vm.visibleItems, function(item) {
        return _c(
          "div",
          {
            key: item.id,
            staticClass: "rounded p-3 bg-gray my-3 item-container"
          },
          [
            _c("div", { staticClass: "row d-flex align-items-center" }, [
              _c("div", { staticClass: "col-12 col-md-2" }, [
                _c("div", { staticClass: "text-center border-right" }, [
                  _c(
                    "span",
                    {
                      staticClass: "badge badge-pill px-3 py-2 font-14",
                      style: {
                        "--item-status-color": _vm.color(item.status.id)
                      }
                    },
                    [_vm._v(" " + _vm._s(item.status.name) + " ")]
                  )
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Nombre del Proponente:")
                ]),
                _c("div", { staticClass: "font-weight-bold" }, [
                  _vm._v(" " + _vm._s(_vm._f("empty")(item.name)) + " ")
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [_vm._v("Teléfono:")]),
                _c("div", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm._f("phone")(item.phoneNumber)))
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Correo Electrónico:")
                ]),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c("validation-provider", {
                      ref: `item-${item.id}`,
                      refInFor: true,
                      attrs: {
                        "custom-messages": {
                          required: "El campo es requerido.",
                          email: "El correo electrónico no es válido."
                        },
                        rules: "required|email"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    disabled: item.disabled,
                                    error: errors[0]
                                  },
                                  model: {
                                    value: item.email,
                                    callback: function($$v) {
                                      _vm.$set(item, "email", $$v)
                                    },
                                    expression: "item.email"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm.isPending(item.status.id)
                      ? _c(
                          "div",
                          { staticClass: "ml-3" },
                          [
                            _c("action-button", {
                              attrs: {
                                i: `fas fa-${item.disabled ? "edit" : "check"}`,
                                variant: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setEmail(item)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              !_vm.isReadOnly && !_vm.isRenewalOrAmendment
                ? _c("div", { staticClass: "col-12 col-md-1 custom-pl" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-md-end h-100"
                      },
                      [
                        _c("check-box", {
                          staticClass: "row-check",
                          attrs: { value: item.checked },
                          on: { input: val => _vm.onToggleSelected(item, val) }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ]
        )
      }),
      0
    ),
    _vm.canShowMore
      ? _c(
          "div",
          { staticClass: "col-12 d-flex justify-content-center my-3" },
          [
            _c(
              "action-button",
              {
                attrs: {
                  variant:
                    "outline-success custom-view-more actionButton rounded-pill"
                },
                on: { click: _vm.loadMore }
              },
              [
                _vm._v(" Ver más "),
                _c("i", { staticClass: "ml-1 fas fa-chevron-down" })
              ]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }